import { billToType } from "entities/checkout-billing-enums"
import { Customer } from "entities/customer"

export const isCCShipTo = function ({ addressNumber }: Customer): boolean {
  return addressNumber === billToType.CASH_CCOnline || addressNumber === billToType.CASH_CCInHand;
}
